<div>
  <form [formGroup]="searchForm">
    <div    class="flex-gap-6-5vw flex-space-between-center flex-row">
      <mat-form-field class="flex-40" >
        <mat-label>CFA Menu ID</mat-label>
        <input matInput
          formControlName="cfaMenuId"
          type="number"
          >
      </mat-form-field>
    </div>
    <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
      <mat-form-field class="flex-40" >
        <mat-label>RMI</mat-label>
        <input matInput
          formControlName="rmi"
          type="number"
          >
      </mat-form-field>
    </div>
    <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
      <mat-form-field class="flex-40" >
        <mat-label>Tag</mat-label>
        <input matInput
          formControlName="tag"
          type="text"
          >
      </mat-form-field>
    </div>
    <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
      <mat-form-field class="flex-40" >
        <mat-label>PIN</mat-label>
        <input matInput
          formControlName="pin"
          type="number"
          >
      </mat-form-field>
    </div>
    <button
      [attr.data-testid]="'search_button'"
      mat-raised-button
      matTooltip="Search"
      (click)="handleSearch()"
      >
      Search
    </button>
    <button
      [attr.data-testid]="'reset_search_button'"
      mat-button
      matTooltip="Reset"
      (click)="resetSearch()"
      >
      Reset
    </button>
  </form>

  <form [formGroup]="form">
    <div class="table-container">
      <table id="item-id-mappings-table" class="emm-item-id-mappings-table">
        <thead>
          <tr id="table-headers">
            <td class="item-id-mappings-table-columns"><label>CfaMenuId</label></td>
            <td class="item-id-mappings-table-columns"><label>RMI</label></td>
            <td class="item-id-mappings-table-columns"><label>Tag</label></td>
            <td class="item-id-mappings-table-columns"><label>PIN</label></td>
            <td class="item-id-mappings-table-columns"></td>
            <td class="item-id-mappings-table-columns"></td>
            <td class="item-id-mappings-table-columns">
              <button mat-button matTooltip="Add Row" id="add-row-button"
              (click)="addNewRowAtTop()">+</button>
            </td>
          </tr>
        </thead>

        <tbody>
          @for (itemIdMapping of getItemIdMappingControls().controls; track itemIdMapping; let i = $index) {
            <ng-container formArrayName="itemIdMappings"
              >
              <tr [formGroupName]="i" class="id-mapping-rows">
                <td class="item-id-mappings-table-columns">
                  <input matInput class="form-control" type="number"
                    readonly="{{ isReadOnly$ | async }}"
                    formControlName="cfaMenuId"
                    [disabled]="!canEdit"/>
                </td>
                <td class="item-id-mappings-table-columns">
                  <input matInput class="form-control" type="number"
                    readonly="{{ isReadOnly$ | async }}"
                    formControlName="rmi"
                    [disabled]="!canEdit"/>
                </td>
                <td class="item-id-mappings-table-columns">
                  <input matInput class="form-control" type="text"
                    readonly="{{ isReadOnly$ | async }}"
                    formControlName="tag"
                    [disabled]="!canEdit"/>
                </td>
                <td class="item-id-mappings-table-columns">
                  <input matInput class="form-control" type="number"
                    readonly="{{ isReadOnly$ | async }}"
                    formControlName="pin"
                    [disabled]="!canEdit"/>
                </td>
                <td class="item-id-mappings-table-columns">
                  <button mat-button matTooltip="Reset Row" type="button"
                    disabled="{{ isReadOnly$ | async }}"
                    (click)="resetRow(i)"
                    [disabled]="!canEdit"
                  >Reset</button>
                </td>
                <td class="item-id-mappings-table-columns">
                  <button mat-button matTooltip="Remove Row" type="button"
                    [disabled]="!canEdit"
                  (click)="removeRow(i)">Remove</button>
                </td>
                <td class="item-id-mappings-table-columns">
                  <button
                    [attr.data-testid]="'delete_button'+i"
                    [disabled]="itemIdMapping.get('id').value == null || !canEdit"
                    mat-raised-button
                    matTooltip="Delete"
                    (click)="doDelete(i)"
                    >
                    Delete
                  </button>
                </td>
              </tr>
            </ng-container>
          }
        </tbody>
      </table>
    </div>
    <button
      id="submit-button"
      [attr.data-testid]="'submit_button'"
      mat-raised-button
      matTooltip="Submit"
      [disabled]="!canEdit"
      (click)="handleSubmit()"
      >
      Submit
    </button>
  </form>
</div>
